export const monthDate = '919';
// 当前数据如果要强刷缓存则变更以下字段
const curDataVersion = 1;

const hasNumEmoji = '💪';
const matchTargetEmoji = '[红包]';

// export const apiUrl = "http://localhost:4000/api";

export const apiUrl = "https://summer-rush.api.9daye.cn/api";

export function getDataVersion() {
    return monthDate + `-${curDataVersion}`
}


const teams = [
    // { group: '所有网格员到店辅导至少1家', type: 'head' },
    // { group: '--------------------------------', type: 'head' },
    // { group: '        [庆祝]【活动日直播榜】[庆祝]', type: 'head' },

    {name: '浙江', store: 419, target: 75},
    {name: '江苏', store: 379, target: 75},
    {name: '广东', store: 377, target: 75},
    {name: '山东', store: 327, target: 75},
    {name: '安徽', store: 227, target: 30},
    {name: '山西', store: 164, target: 30},
    {name: '江西', store: 137, target: 30},
    {name: '福建', store: 132, target: 30},
    {name: '上海', store: 117, target: 25},
    {name: '京津冀', store: 114, target: 25},
    {name: '湖北', store: 100, target: 25},
    {name: '湖南', store: 92, target: 15},
    {name: '云南', store: 78, target: 15},
    {name: '重庆', store: 61, target: 15},
    {name: '陕西', store: 49, target: 15},
    {name: '河南', store: 36, target: 15},
    {name: '贵州', store: 32, target: 15},
    {name: '四川', store: 17, target: 10},

];

export function buildInitData(finishData) {
    return [...teams].map((item) => {

        const id = encodeURI(`${item.name}`);

        const finish = finishData ? (finishData[id] || 0) : 0;

        return {...item, finish, id};
    });
}

const numEmojiMap = [
    '0️⃣',
    '1️⃣',
    '2️⃣',
    '3️⃣',
    '4️⃣',
    '5️⃣',
    '6️⃣',
    '7️⃣',
    '8️⃣',
    '9️⃣',
];

export function convertNum2Emoji(num, minLen) {
    const str = num + '';
    let arr = str.split('');
    // if (minLen && arr.length < minLen) {
    //     let fillArr = new Array(minLen - arr.length).fill('0');
    //     arr = [...fillArr, ...arr];
    // }

    return arr
        .map(n => numEmojiMap[parseInt(n)])
        .join('');
}

const calcTotal = fTeams => {
    return fTeams.map(item => item.finish || 0).reduce((total, item) => total + item, 0)
};


export function formatTxt(fTeams) {
    const total = calcTotal(fTeams);

    let topStr = `吾行养车三大矩阵项目运营
🌟🌟919行动核销600万🌟🌟
💥争流量，冲奖券，拿大奖💥
 总目标6️⃣0️⃣0️⃣万完成${convertNum2Emoji(total, 0)}元
 ⚡各省级分公司目标战报⚡\n`

    const newArr=[...fTeams];
    newArr.sort((a, b) => b.finish-a.finish);

    const next = newArr.map(item => {
        const emojiLen1 = (item.store + '').length;
        const emojiLen2 = (item.target + '').length;
        const emojiLen3 = (item.finish + '').length;

        return `${item.name}${convertNum2Emoji(item.store, emojiLen1)}店${convertNum2Emoji(item.target, emojiLen2)}万完成${convertNum2Emoji(item.finish, emojiLen3)}元`;
    }).join('\n');

    const bottomStr = '\n洗美油轮加膜垫，短直采购和上翻\n' +
        '三大矩阵齐发力，吾行养车最牛逼'

    return topStr + next + bottomStr;
}
